import { render, staticRenderFns } from "./CategoryImage.vue?vue&type=template&id=4c01567c&scoped=true&"
import script from "./CategoryImage.vue?vue&type=script&lang=ts&"
export * from "./CategoryImage.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryImage.vue?vue&type=style&index=0&id=4c01567c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01567c",
  null
  
)

export default component.exports